@if(visible()){
<div class="jk-row-border flex" style="padding:2px">
      <app-jkedit [label]="''" placeholder="程式代號" [(value)]="myMenu.callProgramId" [width]="100"></app-jkedit>
      <button class="btn-normal" [class.btn-primary]="true" (click)="doProgramId()"
            style="min-width: 30px;"><mat-icon>directions_run</mat-icon></button>
</div>

}
